import React from 'react';
import { I18n } from 'react-redux-i18n';
import BUSDChart from '../../../common/busd-chart/BUSDChart';
import { formatPrice, formatTextFloat } from '../../../helpers/Text';
import { fetchBusd, REDUCER_NAME } from './reducer';
import { connect } from 'react-redux';
import ChartContent from './ChartContent';
import moment from 'moment';
import ConstCommon from './../../../common/Const';
import Loading from './../../../common/loading/Loading';
import { customDataChart } from './../../../helpers/Chart';
import { getUnique } from './../../../helpers/Common';
import Const from './Const';
import { ChartFooter } from './../../../common/chart/footer';
import { Translate } from 'react-redux-i18n';

const HEIGHT_CHART = 400;
const BUSD_CHART_HEIGHT = 250;

class Chart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keyChart: getUnique(),
    };
  }

  getTradingDate = tradingDate => {
    return moment(tradingDate)
      .startOf('minute')
      .format('HH:mm')
      .toString();
  };

  groupTwoData = (listIndex, listLiquidity) => {
    const { currentSearch } = this.props;
    const result = [];
    const listIndexByTradingDate = {};

    listIndex.forEach(item => {
      const tradingDate = this.getTradingDate(item.tradingDate);
      listIndexByTradingDate[tradingDate] = item;
    });
    listLiquidity.forEach(item => {
      const tradingDate = this.getTradingDate(item.tradingDate);
      if (currentSearch.isTicker && listIndexByTradingDate[tradingDate]) {
        const {
          matchPrice,
          matchVolume,
          totalMatchValue,
          referencePrice,
        } = listIndexByTradingDate[tradingDate];
        const now = moment().format('HH:mm');
        const isNoData = matchPrice === undefined;
        if (now > tradingDate && isNoData && result.length) {
          return result.push({
            ...item,
            ...result[result.length - 1],
            matchVolumeIndex: matchVolume || 0,
          });
        }

        const prevRefPrice = result.length
          ? result[result.length - 1].referenceIndex * 1000
          : 0;
        const prevTotalMatchValue = result.length
          ? result[result.length - 1].totalMatchValue
          : 0;
        return result.push({
          ...item,
          indexValue:
            matchPrice !== undefined ? formatPrice(matchPrice) : undefined,
          indexValueIndex:
            matchPrice !== undefined ? formatPrice(matchPrice) : undefined,
          matchVolumeIndex: matchVolume,
          totalMatchValueIndex: totalMatchValue,
          referenceIndex: formatPrice(referencePrice || prevRefPrice),
          totalMatchValue: item.totalMatchValue || prevTotalMatchValue,
        });
      }

      if (listIndexByTradingDate[tradingDate]) {
        const prevTotalMatchValue = result.length
          ? result[result.length - 1].totalMatchValue
          : 0;
        const {
          indexValue,
          matchVolume,
          totalMatchValue,
          referenceIndex,
        } = listIndexByTradingDate[tradingDate];

        const now = moment().format('HH:mm');
        const isNoData = indexValue === undefined;
        if (now > tradingDate && isNoData && result.length) {
          return result.push({
            ...item,
            ...result[result.length - 1],
            matchVolumeIndex: matchVolume || 0,
          });
        }

        result.push({
          ...item,
          indexValueIndex: indexValue,
          matchVolumeIndex: matchVolume,
          totalMatchValueIndex: totalMatchValue,
          referenceIndex: referenceIndex,
          totalMatchValue: item.totalMatchValue || prevTotalMatchValue,
        });
      } else {
        const length = result.length;
        if (length > 0) {
          result.push({
            ...item,
            ...result[length - 1],
            tradingDate: item.tradingDate,
          });
        }
      }
    });

    return result;
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if (
      this.props.component !== nextProps.component ||
      this.props.listIndex !== nextProps.listIndex ||
      this.props.listLiquidity !== nextProps.listLiquidity
    ) {
      this.setState({ keyChart: getUnique() });
    }
  }

  getReferencePriceIndex = listIndexCustom => {
    const { currentSearch } = this.props;
    if (currentSearch.isTicker) {
      if (!Array.isArray(listIndexCustom) || !listIndexCustom.length) {
        return 0;
      }

      return formatPrice(listIndexCustom[0].referencePrice || 0);
    }

    const length = listIndexCustom.length;
    return length > 0 ? listIndexCustom[length - 1].referenceIndex : 0;
  };

  getWidthChart = () => {
    const { component } = this.props;

    return component.width - 80; //minus padding
  };

  renderFooter = () => {
    const { timeRange } = this.props;
    const textI18n = `marketInDepthLiquidity.LABEL_CHART_BOTTOM_AVG.${timeRange}`;

    return (
      <ChartFooter
        list={[
          {
            text: 'marketInDepthLiquidity.LABEL_CHART_BOTTOM_TODAY',
            color: '#009cff',
            type: 'circle',
          },
          {
            text: textI18n,
            color: '#ffc859',
            type: 'circle',
          },
        ]}
      />
    );
  };

  renderWithNodata = () => {
    return <Translate value={'common.NO_DATA'} />;
  };

  getBuSdProps = () => {
    const { currentSearch } = this.props;
    return currentSearch.isTicker
      ? {}
      : {
          yAxisRightTickFormat: d => formatTextFloat(d),
          thirdLegendKey: 'common.busd.index',
          rightI18nKey: 'common.busd.index',
        };
  };

  render() {
    const {
      listIndex,
      listLiquidity,
      timeRange,
      isLoading,
      busd,
      fetchBusd,
      priceData,
      currentSearch,
    } = this.props;

    const { keyChart } = this.state;

    const listIndexCustom = customDataChart(
      listIndex,
      ConstCommon.timeRange['1D'],
    );
    const listLiquidityCustom = customDataChart(
      listLiquidity,
      ConstCommon.timeRange['1D'],
    );
    const data = this.groupTwoData(listIndexCustom, listLiquidityCustom);

    return (
      <div className={`position-relative`} style={{ height: HEIGHT_CHART }}>
        {isLoading && <Loading />}
        <div className={isLoading ? 'bg-blur' : ''}>
          {listIndex.length > 0 && listLiquidity.length > 0 ? (
            <>
              <ChartContent
                key={keyChart}
                data={data}
                width={this.getWidthChart()}
                height={HEIGHT_CHART}
                ratio={window.devicePixelRatio}
                referencePrice={this.getReferencePriceIndex(listIndexCustom)}
                displayTimeRange={Const.displayTimeRange[timeRange]}
              />
              {this.renderFooter()}
              {Const.timeRange.ONE_DAY === timeRange && (
                <BUSDChart
                  currentSearch={currentSearch}
                  priceData={priceData}
                  callbackInterval={fetchBusd}
                  {...this.getBuSdProps()}
                  title={I18n.t('marketInDepthLiquidity.busdTitle')}
                  height={BUSD_CHART_HEIGHT}
                  width={this.getWidthChart()}
                  data={busd}
                />
              )}
            </>
          ) : (
            !isLoading && this.renderWithNodata()
          )}
        </div>

        {!isLoading && (
          <div className="unit-title-note">
            {I18n.t(
              currentSearch.isTicker
                ? 'marketInDepthLiquidity.footerNote'
                : 'marketInDepthLiquidity.footerNoteIndex',
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    listLiquidity: state[REDUCER_NAME].listLiquidity,
    listIndex: state[REDUCER_NAME].listIndex,
    component: state[REDUCER_NAME].component,
    timeRange: state[REDUCER_NAME].timeRange,
    isLoading: state[REDUCER_NAME].isLoading,
    busd: state[REDUCER_NAME].busd,
    i18n: state.i18n,
    currentSearch: state[REDUCER_NAME].currentSearch,
  };
};

const mapDispatchToProps = {
  fetchBusd,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Chart);
